import HomePage from "./home";
import AboutUs from "./about-us";
import Album from "./album";
import Services from "./services";
import Contact from "./contact";

const Content: React.FC<{}> = () => {
  return (
    <div className="website-wrapper">
      <HomePage />
      <AboutUs />
      <Services />
      <Album />
      <Contact />
    </div>
  );
};

export default Content;
